appRun.$inject = ['$rootScope', '$window', '$state', '$transitions', 'MetatagService'];

function appRun($rootScope, $window, $state, $transitions, MetatagService) {
    $rootScope.reloadProyect = false;
    $rootScope.reloadProyectState = '';

    MetatagService.setDefaultTags({
        // General SEO

    });



    $transitions.onSuccess({to: 'home.**'}, function (trans1, trans) {


        $("html, body").stop().animate({scrollTop: 0}, 200, 'swing');

        if ($rootScope.reloadProyect) {
            $rootScope.reloadProyect = false;
            $state.go($rootScope.reloadProyectState);
            // $timeout(() => {
            //   $state.reload();
            // }, 1000);
        }

        /*let state = trans1.to();
        let article = trans1.injector().get('resolvedArticle');
        MetatagService.setTags({
            // General SEO
            'title': article.title,
            // OpenGraph
            'og:type': 'article',
            'og:title': article.title,
            'og:description': article.description,
            'og:image': article.image,
            // Twitter
            'twitter:card': 'summary_large_image',
            'twitter:creator': article.twitter_id,
            'twitter:title': article.title,
            'twitter:description': article.description,
            'twitter:image': article.image,
        });*/


    });
}

export default appRun;



// WEBPACK FOOTER //
// ./www/components/app.run.js